import cx from 'classnames';

import { KatexStyles } from './KatexStyles';
import styles from './markdown.module.scss';
import { MdRenderOptions, convertHtmlToReactElement, convertMarkdownToHtml } from './utils';

interface ServerProps {
  content: string;
  className?: string;
  options?: MdRenderOptions;
}

export const MDServerRenderer = async ({ content, className, options }: ServerProps) => {
  const markdownToHtml = await convertMarkdownToHtml(content, options);
  const { result } = await convertHtmlToReactElement(markdownToHtml ?? '');

  return (
    <>
      <KatexStyles />
      <aside className={cx(styles.wrapper, className)}>
        <div>{result}</div>
      </aside>
    </>
  );
};
